"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hasChildren = void 0;

var is_empty_1 = require("./is-empty");

function hasChildren(item) {
  return typeof item === 'object' && 'children' in item && (0, is_empty_1.isNotEmpty)(item.children);
}

exports.hasChildren = hasChildren;